import createIcon from '../../createIcon';

/**
 * @component @name StayPrimaryPortrait
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuOTk0OSAxLjAxTDYuOTk0ODggMUM1Ljg5NDg4IDEgNS4wMDQ4OCAxLjkgNS4wMDQ4OCAzVjIxQzUuMDA0ODggMjIuMSA1Ljg5NDg4IDIzIDYuOTk0ODggMjNIMTYuOTk0OUMxOC4wOTQ5IDIzIDE4Ljk5NDkgMjIuMSAxOC45OTQ5IDIxVjNDMTguOTk0OSAxLjkgMTguMDk0OSAxLjAxIDE2Ljk5NDkgMS4wMVpNMTYuOTk0OSAxOUg2Ljk5NDg4VjVIMTYuOTk0OVYxOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const StayPrimaryPortrait = createIcon('StayPrimaryPortrait', [
  [
    'path',
    {
      d: 'M16.9949 1.01L6.99488 1C5.89488 1 5.00488 1.9 5.00488 3V21C5.00488 22.1 5.89488 23 6.99488 23H16.9949C18.0949 23 18.9949 22.1 18.9949 21V3C18.9949 1.9 18.0949 1.01 16.9949 1.01ZM16.9949 19H6.99488V5H16.9949V19Z',
      key: '4iuhtz',
    },
  ],
]);

export default StayPrimaryPortrait;
